import { render, staticRenderFns } from "./CreateFolderItemIcon.vue?vue&type=template&id=717aa410&scoped=true"
import script from "./CreateFolderItemIcon.vue?vue&type=script&lang=js"
export * from "./CreateFolderItemIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717aa410",
  null
  
)

export default component.exports